/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Case_Payment_Status_LabelInputs */

const en_case_payment_status_label = /** @type {(inputs: Case_Payment_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "paid") return /** @type {LocalizedString} */ (`Paid`);
	if (i?.status === "overdue") return /** @type {LocalizedString} */ (`Overdue`);
	if (i?.status === "upcoming") return /** @type {LocalizedString} */ (`Upcoming`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

const pt_br2_case_payment_status_label = /** @type {(inputs: Case_Payment_Status_LabelInputs) => LocalizedString} */ (i) => {
	if (i?.status === "paid") return /** @type {LocalizedString} */ (`Pago`);
	if (i?.status === "overdue") return /** @type {LocalizedString} */ (`Vencido`);
	if (i?.status === "upcoming") return /** @type {LocalizedString} */ (`A vencer`);
	return /** @type {LocalizedString} */ (`${i?.status}`)
	
};

/**
* | status | output |
* | --- | --- |
* | "paid" | "Paid" |
* | "overdue" | "Overdue" |
* | "upcoming" | "Upcoming" |
* | * | "{status}" |
*
* @param {Case_Payment_Status_LabelInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_payment_status_label = /** @type {((inputs: Case_Payment_Status_LabelInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Payment_Status_LabelInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_payment_status_label(inputs)
	return pt_br2_case_payment_status_label(inputs)
});